import React from "react";

export default function ({
  size,
  circled,
  className = "",
}: {
  size?: number;
  circled?: boolean;
  className?: string;
}) {
  const svg = (
    <svg
      className={className}
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
  if (circled) {
    return <div className={"ib circled-icon" + " " + className}>{svg}</div>;
  }
  return svg;
}
